import queryString from 'query-string';
import env from 'utils/env';
import request from './request';
import requestJson from './requestJson';

export const getCarts = (campaignId, skus, accountCodes) => {
  const queryParams = {
    ...(skus && { skus: skus.split(',') }),
    ...(accountCodes && { accountCodes: accountCodes.split(',') }),
  };
  const requestUrl = `${
    env.aceApi
  }/1/carts/campaigns/${campaignId}?${queryString.stringify(queryParams, {
    arrayFormat: 'comma',
  })}`;
  return requestJson(requestUrl, 'GET');
};

export const getRefillsCarts = (skus, accountCodes) => {
  const queryParams = {
    ...(skus && { skus: skus.split(',') }),
    ...(accountCodes && { accountCodes: accountCodes.split(',') }),
  };
  const requestUrl = `${
    env.refillsApi
  }/admin/subscriptions/?${queryString.stringify(queryParams, {
    arrayFormat: 'comma',
  })}`;
  return request(requestUrl, 'GET');
};

export const getCartEvents = (campaignId, skus, accountCodes) => {
  const queryParams = {
    ...(skus && { skus: skus.split(',') }),
    ...(accountCodes && { accountCodes: accountCodes.split(',') }),
  };
  const requestUrl = `${
    env.aceApi
  }/1/admin/cart-events/campaigns/${campaignId}?${queryString.stringify(
    queryParams,
    { arrayFormat: 'comma' }
  )}`;
  return request(requestUrl);
};
